/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.DashboardGoals {


    import GoalCategoryEnum = Meevo.Components.Goals.GoalCategoryEnum;
    import GoalInputTypeEnum = Meevo.Components.Goals.GoalInputTypeEnum;
    import IGoalColumn = Meevo.Components.Goals.IGoalColumn;

    export const INPUT_TYPE_KEY = {
        [GoalInputTypeEnum.Currency]: 'amount',
        [GoalInputTypeEnum.Percentage]: 'percent',
        [GoalInputTypeEnum.Numeric]: 'unit',
    };

    export const GOAL_CATEGORY_LABELS = {
        [GoalCategoryEnum.AverageRetailTicket]: 'LABEL_RETAIL',
        [GoalCategoryEnum.AverageServiceTicket]: 'LABEL_SERVICE',
        [GoalCategoryEnum.AverageTicket]: 'LABEL_TICKET',
        [GoalCategoryEnum.Retail]: 'LABEL_RETAIL',
        [GoalCategoryEnum.Service]: 'LABEL_SERVICE',
        [GoalCategoryEnum.FrequencyOfVisit]: 'LABEL_FREQUENCY_OF_VISIT',
        [GoalCategoryEnum.NewClientsPerMonth]: 'LABEL_NEW_CLIENTS_PER_MONTH',
        [GoalCategoryEnum.RequestRate]: 'LABEL_REQUEST',
        [GoalCategoryEnum.NewClientRetention]: 'LABEL_NEW_CLIENTS',
        [GoalCategoryEnum.Rating]: 'LABEL_5_STAR_RATING',
        [GoalCategoryEnum.RepeatClientRetention]: 'LABEL_REPEAT_CLIENTS',
        [GoalCategoryEnum.Membership]: 'LABEL_MEMBERSHIPS',
        [GoalCategoryEnum.Productivity]: 'LABEL_PRODUCTIVITY',
        [GoalCategoryEnum.GiftCard]: 'LABEL_GIFT_CARD_SALES',
    };

   export const LABEL_MONTH = [
        'LABEL_MONTH_JANUARY',
        'LABEL_MONTH_FEBRUARY',
        'LABEL_MONTH_MARCH',
        'LABEL_MONTH_APRIL',
        'LABEL_MONTH_MAY',
        'LABEL_MONTH_JUNE',
        'LABEL_MONTH_JULY',
        'LABEL_MONTH_AUGUST',
        'LABEL_MONTH_SEPTEMBER',
        'LABEL_MONTH_OCTOBER',
        'LABEL_MONTH_NOVEMBER',
        'LABEL_MONTH_DECEMBER',
    ];

    export interface IBarChartItem {
        label: string;
        value: number;
        color: number;
    }

    export interface ICircleBarChartItem {
        key: string;
        y: number;
    }

    export interface DateRangeListItem {
        value: GoalDateRangeEnum;
        label: string;
    }

    export interface DateRangeList extends Array<DateRangeListItem> {
    }

    export interface IDashboardGoalsGraphsLogic {
        prepareFilter(arr: IDashboardGoalColumn[]): DateRangeList;

        barChartMapFn(list: IGoalColumn[], dateRange: GoalDateRangeEnum, $translate: ng.translate.ITranslateService, keyEnum?: GoalInputTypeEnum, hasMonthly?: boolean): IBarChartItem[];

        createDonutChart(numGoal: number, numActual: number, id: string);

        createBarChart(numGoal: number, numActual: number, id: string);

        createGaugeChart(numGoal: number, numActual: number, id: string);
    }
    declare let d3: any;

    class DashboardGoalsGraphsLogic implements IDashboardGoalsGraphsLogic {

        
        private isValidData(num: number): boolean {
            return (!_.isUndefined(num) && !_.isNaN(num) && !_.isNull(num) && num !== 0)
        }

        public static factory() {
            const instance = () => {
                return new DashboardGoalsGraphsLogic();
            };

            instance.$inject = [];

            return instance;
        }
        
        // create bar chart
        createBarChart = (numGoal: number, numActual: number, id: string) => {

            let width: number = 180;
            let height: number = 160;
            let defaultBarHeight: number = 2;
            let defaultYValue: number = height - defaultBarHeight;
            let thickness: number = 40;
            let duration: number = 800;
            let foregroundColor: string = "#72b8ff";
            let backgroundColor: string = "#ccc";
            let percent: number = numActual;
            let margin = {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
            };
            let groupBarPadding = .2;
            let individualBarPadding = 4;
            var color = d3.scaleOrdinal([backgroundColor, foregroundColor]);

            const categories = ['goals', 'actuals'];

            let data = [
                {
                    subCategory: 'goals',
                    value: numGoal = numGoal ? numGoal : 0
                },
                {
                    subCategory: 'actual',
                    value: numActual = numActual ? numActual: 0
                }
            ];

            const selector = d3.select(id);

            if (selector.select('svg').empty()) {
                selector.append('svg')
            }


            if (selector.select('svg').empty()) {
                selector.select('svg')
                    .attr('class', 'bar-chart')
                    .attr('preserveAspectRatio', 'xMinYMin meet')
                    .attr("viewBox", `0 0 ${width} ${height}`)
                    .attr('width', width)
                    .attr('height', height)
                    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
            }
            else {
                selector.select('svg').selectAll('*').remove();
            }

            const x = d3.scaleBand().rangeRound([0, width]).padding(groupBarPadding);
            const y = d3.scaleLinear().rangeRound([height, 0]);

            const xAxis = d3.axisBottom(x)
                .tickValues([])
                .tickSize(0);

            // Chart placement
            selector.select('svg')
                .attr('width', width)
                .attr('height', height)
                .attr("viewBox", `0 0 ${width} ${height}`)
                .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')


            x.domain(data.map(function (d) { return d.subCategory; }));

            y.domain([0, d3.max(data, function (d) { return d.value; })]);

            // Draw x-axis
            selector.select('svg').append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0, ' + height + ')')
                .call(xAxis)
                .selectAll('text')
                .attr('class', 'svg-category-label')

            // Hide label
            selector.select('svg').selectAll('.svg-category-label')
                .attr('display', 'none')

            let goalRatio: number = 0;

            if (numActual > 0) { goalRatio = (numGoal / numActual) };
            
            let getRectYAttr = (d: any, i: number): number => {

                if (this.isValidData(numGoal) && this.isValidData(numActual) && numGoal > 0) {
                    return y(d.value);
                }
                else if ((_.isUndefined(numGoal) && _.isUndefined(numActual)) || (_.isNull(numGoal) && _.isNull(numActual))) {
                    return defaultYValue;
                }
                // if numgoal is valid but num actual is invalid
                else if ((this.isValidData(numGoal) && !this.isValidData(numActual)) || goalRatio > 100) {
                    return i == 0 ? 0 : defaultYValue;
                }
                // if numgoal is invalid but numactual is valid
                else if ((!this.isValidData(numGoal) && this.isValidData(numActual)) || (this.isValidData(goalRatio) && (goalRatio < 0.02 && goalRatio > 0))) {
                    return i == 0 ? defaultYValue : 0;
                }
                else {
                    return defaultYValue;
                }
            }

            let getRectHeightAttr = (d: any, i: number): number => {

                if (this.isValidData(numGoal) && this.isValidData(numActual)) {
                    return height - y(d.value)
                    
                }
                // if numgoal is valid but num actual is invalid
                else if ((this.isValidData(numGoal) && !this.isValidData(numActual)) || goalRatio > 100) {
                    return i == 0 ? height : defaultBarHeight;
                }
                // if numgoal is invalid but numactual is valid
                else if ((!this.isValidData(numGoal) && this.isValidData(numActual) && numActual > 0) || (goalRatio < 0.02 && goalRatio > 0)) {
                    return i == 0 ? defaultBarHeight : height;
                }
                else {
                    return defaultBarHeight;
                }
                
            }

            selector.select('svg').selectAll('rect')
                .data(data)
                .enter().append('rect')
                .attr('class', function (d, i) {
                    return i > 0 ? 'actual-bar' : 'goal-bar';
                })
                .attr('x', function (d) { return x(d.subCategory) })
                .attr('y', function (d) { return y(0) })
                .attr('width', x.bandwidth())
                .attr('fill', d => color(d.subCategory))

            // Transition animation
            selector.select('svg').selectAll('rect')
                .transition()
                .delay(200)
                .duration((d) => {
                    return d.value > 0 ? duration : 0;
                })
                .attr('y', function (d, i) {
                    return getRectYAttr(d, i);
                })
                .attr('height', function (d, i) {
                    return getRectHeightAttr(d, i);
                });

        }
        

        // create donut chart
        createDonutChart = (numGoal: number, numActual: number, id: string) => {


            //let width: number = 200;
            //let height: number = 200;
            let width: number = 180;
            let height: number = 180;
            let thickness: number = 40;
            let duration: number = 800;
            let foregroundColor: string = "#72b8ff";

            let backgroundColor: string = "#e2e0e0";

            let percent: number;

            if (numGoal > 0) {
                percent = numActual / numGoal;
            }

            let radius: number = Math.min(width, height) / 2;
            var color = d3.scaleOrdinal([foregroundColor, backgroundColor]);

            const selector = d3.select(id);

            if (selector.select('svg').empty()) {
                selector.append('svg')
            }

            if (selector.select('svg').empty()) {
                selector.select('svg')
                    .attr('class', 'pie')
                    .attr('width', width)
                    .attr('height', height)
                    .attr("viewBox", `0 0 ${width} ${height}`);
            }
            else {
                selector.select('svg').selectAll('*').remove();
                selector.select('svg')
                    .attr('class', 'pie')
                    .attr('width', width)
                    .attr('height', height)
                    .attr("viewBox", `0 0 ${width} ${height}`);
            }

            var g = selector.select('svg').append('g')
                .attr('transform', 'translate(' + (width / 2) + ',' + (height / 2) + ')');

            var arc = d3.arc()
                .innerRadius(radius - thickness)
                .outerRadius(radius);

            var pie = d3.pie()
                .padAngle(0.02)
                .sort(null);

            var path = g.selectAll('path')
                .data(pie([0, 1]))
                .enter()
                .append('path')
                .attr('d', arc)
                .attr('fill', function (d, i) {
                    return color(i);
                })
                .each(function (d) { this._current = d; });



            if (percent == 0 || _.isUndefined(percent) || _.isNaN(percent)) {
                // set donut chart to show a small 1%
                path.data(pie([0.5, 99.5])).transition()
                    .duration(duration)
                    .attrTween('d', function (d) {
                        var interpolate = d3.interpolate(this._current, d);
                        this._current = interpolate(0);
                        return function (t) {
                            return arc(interpolate(t));
                        }
                    });
            }
            else if (percent > 1) {
                path.data(pie([1, 0])).transition()
                    .duration(duration)
                    .attrTween('d', function (d) {
                        var interpolate = d3.interpolate(this._current, d);
                        this._current = interpolate(0);
                        return function (t) {
                            return arc(interpolate(t));
                        }
                    });
            }
            else {
                path.data(pie([percent, 1 - percent])).transition()
                    .duration(duration)
                    .attrTween('d', function (d) {
                        var interpolate = d3.interpolate(this._current, d);
                        this._current = interpolate(0);
                        return function (t) {
                            return arc(interpolate(t));
                        }
                    });
            }
        }


        // create multibarchartwithline


        // create gauge chart
        createGaugeChart = (numGoal: number, numActual: number, id: string) => {

            let width: number = 270;
            let height: number = 180;
            let thickness: number = 40;
            let duration: number = 800;
            let foregroundColor: string = "#72b8ff";
            let backgroundColor: string = "#e2e0e0";
            let percent: number = 0;

            if (numGoal > 0) {
                percent = numActual / numGoal;
            }

            let radius: number = Math.min(width / 2, height);


            var color = d3.scaleOrdinal([foregroundColor, backgroundColor]);
            const selector = d3.select(id);

            if (selector.select('svg').empty()) {
                selector.append('svg')
            }

            if (selector.select('svg').empty()) {
                selector.select('svg')
                    .attr('class', 'pie')
                    .attr('width', width)
                    .attr('height', height)
                    .attr("viewBox", `0 0 ${width} ${height}`);
            }
            else {
                selector.select('svg').selectAll('*').remove();
                selector.select('svg')
                    .attr('class', 'pie')
                    .attr('width', width)
                    .attr('height', height)
                    .attr("viewBox", `0 0 ${width} ${height}`);
            }

            var g = selector.select('svg').append('g')
                .attr('transform', 'translate(' + (width / 2) + ',' + (height) + ')');

            var arc = d3.arc()
                .innerRadius(radius - thickness)
                .outerRadius(radius);

            var pie = d3.pie()
                .padAngle(0.02)
                .sort(null)
                .startAngle((-.5) * Math.PI)
                .endAngle(.5 * Math.PI);

            var path = g.selectAll('path')
                .data(pie([0, 1]))
                .enter()
                .append('path')
                .attr('d', arc)
                .attr('fill', function (d, i) {
                    return color(i);
                })
                .each(function (d) { this._current = d; });

            if (percent == 0 || _.isUndefined(percent) || _.isNaN(percent)) {
                // set donut chart to show a small 1%
                path.data(pie([0.5, 99.5])).transition()
                    .duration(0)
                    .attrTween('d', function (d) {
                        var interpolate = d3.interpolate(this._current, d);
                        this._current = interpolate(0);
                        return function (t) {
                            return arc(interpolate(t));
                        }
                    });
            }
            else {
                path.data(pie([percent, 1 - percent])).transition()
                    .duration(duration)
                    .attrTween('d', function (d) {
                        var interpolate = d3.interpolate(this._current, d);
                        this._current = interpolate(0);
                        return function (t) {
                            return arc(interpolate(t));
                        }
                    });
            }

        }


        /**
         * Generates data for the bar charts
         */
        barChartMapFn(list: IGoalColumn[], dateRange: GoalDateRangeEnum, $translate: ng.translate.ITranslateService, keyEnum: GoalInputTypeEnum = GoalInputTypeEnum.Currency, hasMonthly: boolean = false): IBarChartItem[] {
            const key = INPUT_TYPE_KEY[keyEnum];
            const isMonthly = hasMonthly && (dateRange === GoalDateRangeEnum.YearToDate || dateRange === GoalDateRangeEnum.LastTwelveMonths);

            return (_.groupBy(list, 'dateRangeEnum')[dateRange] || [])
                .sort((a: IDashboardGoalColumn, b: IDashboardGoalColumn) => a.year - b.year || a.month - b.month)
                .reduce((all, item: IGoalColumn) => {
                    if (isMonthly && item.month === 0) {
                        return all;
                    }

                    let actualValue = item[`actual${key.slice(0, 1).toUpperCase() + key.slice(1)}`] || 0;
                    let value = item[key] || 0;

                    if (keyEnum === GoalInputTypeEnum.Percentage) {
                        actualValue = actualValue * 100;
                        value = value * 100;
                    }

                    all.push({
                        label: isMonthly ?
                            `${$translate.instant(LABEL_MONTH[item.month - 1])}` :
                            `${$translate.instant('LABEL_ACTUAL')} ${GOAL_CATEGORY_LABELS[item.goalCategory]}`,
                        value: actualValue,
                        color: actualValue >= value ? 'green' : 'red'
                    }, {
                        label: isMonthly ?
                            ` ${$translate.instant(LABEL_MONTH[item.month - 1])}` :
                            `${$translate.instant('LABEL_GOAL')} ${GOAL_CATEGORY_LABELS[item.goalCategory]}`,
                        value: value,
                        color: '#512DA8'
                    });

                    return all;
            }, []);
        }

        /**
         * Generates filter for the chart (YTD, Moths etc...)
         */
        prepareFilter(arr: IDashboardGoalColumn[]): DateRangeList {
            return _.chain(arr)
                .map((item) => item.dateRangeEnum)
                .uniq()
                .map((num) => ({
                    value: num,
                    label: DATE_RANGES[num]
                }))
                .value();
        }
    }


    angular.module('meevo.plugins.dashboardGoals')
        .service('meevo.plugins.docsAndForms.DashboardGoalsGraphsLogic', DashboardGoalsGraphsLogic.factory());
}
